<div class="d-flex flex-column">
	<mat-progress-bar class="mb-4" mode="determinate" [value]="orderProgress"></mat-progress-bar>

	<div class="h4">
		<div class="p-grid">
			<div class="p-col">
				{{ ooStyles.statusOrderAssembling }}
			</div>
			<div class="p-col justify-content-end" style="text-align: right">
				<fa-icon [icon]="['far', 'check-double']"></fa-icon>
			</div>
		</div>
	</div>
	<div class="h4" *ngIf="orderRequiresPayment">
		<div class="p-grid">
			<div class="col-11">
				{{ ooStyles.statusOrderPaymentAuth }}
			</div>
			<div class="p-col justify-content-end" style="text-align: right">
				<p-skeleton *ngIf="!orderSteps.submitted"></p-skeleton>
				<fa-icon *ngIf="orderSteps.authorized" [icon]="['far', 'check-double']"></fa-icon>
			</div>
		</div>
	</div>
	<div class="h4">
		<div class="p-grid">
			<div class="col-11">
				{{ ooStyles.statusOrderSubmitted }}
			</div>
			<div class="p-col justify-content-end" style="text-align: right">
				<p-skeleton *ngIf="!orderSteps.submitted"></p-skeleton>
				<fa-icon *ngIf="orderSteps.submitted" [icon]="['far', 'check-double']"></fa-icon>
			</div>
		</div>
	</div>
	<div class="h4">
		<div class="p-grid">
			<div class="col-11">
				{{ ooStyles.statusOrderQueued }}
			</div>
			<div class="p-col justify-content-end" style="text-align: right">
				<p-skeleton *ngIf="!orderSteps.queued"></p-skeleton>
				<fa-icon *ngIf="orderSteps.queued" [icon]="['far', 'check-double']"></fa-icon>
			</div>
		</div>
	</div>
	<div class="h4" *ngIf="!isFutureOrder">
		<div class="p-grid">
			<div class="col-11">
				{{ ooStyles.statusOrderSentToPos }}
			</div>
			<div class="p-col justify-content-end" style="text-align: right">
				<p-skeleton *ngIf="!orderSteps.injected"></p-skeleton>
				<fa-icon *ngIf="orderSteps.injected" [icon]="['far', 'check-double']"></fa-icon>
			</div>
		</div>
	</div>
	<div class="h4" *ngIf="!isFutureOrder">
		<div class="p-grid">
			<div class="col-11">
				{{ ooStyles.statusOrderMobileCheckSave }}
			</div>
			<div class="p-col justify-content-end" style="text-align: right">
				<p-skeleton *ngIf="!orderSteps.mobileCheckSave"></p-skeleton>
				<fa-icon *ngIf="orderSteps.mobileCheckSave" [icon]="['far', 'check-double']"></fa-icon>
			</div>
		</div>
	</div>
</div>
